import { Component, Input, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ThemeService } from '@wm-libs/core';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { NgClass, NgIf } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { AccountsService } from '../../services/accounts.service';

@Component({
  selector: 'app-empty-data',
  templateUrl: './empty-data.component.html',
  styleUrls: ['./empty-data.component.scss'],
  standalone: true,
  imports: [NgClass, NgIf, MatButtonModule, RouterLink, TranslateModule],
})
export class EmptyDataComponent implements OnDestroy {
  @Input() data!: string;
  env = environment;

  private themeSubscription: Subscription;

  isDarkMode$!: boolean;

  constructor(private themeService: ThemeService, private accountService: AccountsService, public dialog: MatDialog) {
    this.themeSubscription = this.themeService.isDarkMode$.subscribe((isDarkMode) => {
      this.isDarkMode$ = isDarkMode;
    });
  }

  openDialog() {
    this.accountService.connect().subscribe();
  }

  ngOnDestroy(): void {
    if (this.themeSubscription) this.themeSubscription.unsubscribe();
  }
}
